// extracted by mini-css-extract-plugin
export default {"container_bu":"globals_container_bu__0VeMj","columns":"globals_columns__-sp9+"};